import { Heading } from '@simplywallst/ui-core/next';

import ChevronRightSolid from '@simplywallst/ui-core/icons/ChevronRightSolid';
import TickSolid from '@simplywallst/ui-core/icons/TickSolid';

import {
  ManualPortfolioProvider,
  useManualPortfolioContext,
  useManualPortfolioTracking,
} from '@/features/portfolio/components/PortfolioManual';

const NewManualPortfolio = () => {
  const { trackManualPortfolioEvent } = useManualPortfolioTracking();
  const { createPortfolio } = useManualPortfolioContext();

  return (
    <button
      type="button"
      className="group/portfolio relative grid size-full cursor-pointer items-start overflow-hidden px-x2 py-x3 focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-accent focus-visible:duration-0 sm:p-x3"
      onClick={() => {
        trackManualPortfolioEvent({
          modifier: 'create-portfolio',
          action: 'click',
        });
        createPortfolio();
      }}
      aria-label="Create manual portfolio"
    >
      <section data-cy-id="portfolio-manual-creation">
        <div className="pointer-events-none absolute inset-0 bg-p-white-100 opacity-0 transition-opacity duration-300 group-hover/portfolio:opacity-[.01]" />
        <div className="relative grid gap-x2 text-start @container/tile sm:gap-x3">
          <div className="grid gap-x1_5">
            <div className="grid grid-cols-[max-content_auto] items-center gap-2">
              <Heading as="h2" className="text-solid">
                Create by adding holdings
              </Heading>
              <ChevronRightSolid className="size-5 fill-p-white-100 transition-transform duration-500 group-hover/portfolio:translate-x-2" />
            </div>

            <p className="mb-x1 text-pretty text-xs text-soft">
              Add your stocks with quantity and average price for a quick
              portfolio overview
            </p>

            <div>
              <span className="mb-x0_5 mr-x1 py-1 text-tiny text-soft">
                Returns analysis
              </span>
              <span className="mb-x0_5 mr-x0_5 inline-grid grid-cols-[max-content_auto] items-center gap-x0_5 rounded-md bg-surface-3 px-2 py-1">
                <span className="text-pretty text-tiny text-solid">
                  Unrealised
                </span>
                <TickSolid className="size-5 fill-p-green" />
              </span>
            </div>
          </div>
        </div>
      </section>
    </button>
  );
};

const WithProvider = () => {
  return (
    <ManualPortfolioProvider>
      <NewManualPortfolio />
    </ManualPortfolioProvider>
  );
};

export { WithProvider as NewManualPortfolio };
